/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 个人稿库Js
 */
'use strict';

angular
    .module('personalLibraryModule', [
        'editPageModule', //ugc新建 编辑
        'imageTextModule', //pgc图文新建
        'atlasModule', //pgc图集新建
        'videoModule', //pgc视频
        'activityModule', //pgc活动
        'manuscriptDetailsModule' //稿件详情
    ])
    .controller('personalLibraryCtrl', [
        '$scope',
        '$state',
        'httpService',
        '$filter',
        'modalDialog',
        'trsspliceString',
        function ($scope, $state, httpService, $filter, modalDialog, trsspliceString) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化参数
             */
            function initStatus() {
                $scope.status = {
                    statusOptions: '',
                    theDocTypeOptions: [
                        {
                            name: '全部类型',
                            value: '-1'
                        },
                        {
                            name: '新闻',
                            value: '0'
                        },
                        {
                            name: '视频',
                            value: '2'
                        },
                        {
                            name: '图集',
                            value: '3'
                        }
                    ],
                    theDocType: {
                        name: '全部类型',
                        value: '-1'
                    }
                };
                $scope.data = {
                    listData: [],
                    keywords: '', //检索的关键词
                    selectedArray: [] //选中的数据
                };
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 12,
                    ITEMCOUNT: 0
                };
                $scope.params = {
                    startTime: '',
                    endTime: '',
                    searchWord: '',
                    searchTime: '',
                    currPage: $scope.page.CURRPAGE,
                    pageSize: $scope.page.PAGESIZE
                };
                $scope.status.theFirstTypeOptions = [
                    {
                        name: '一级分类',
                        value: ''
                    }
                ];
                $scope.status.theFirstType = angular.copy($scope.status.theFirstTypeOptions[0]);
                $scope.status.theSecondTypeOptions = [
                    {
                        name: '二级分类',
                        value: ''
                    }
                ];
                $scope.status.theSecondType = angular.copy($scope.status.theSecondTypeOptions[0]);
                addChildRefresh();
            }
            $scope.getDocTypeName = function(item) {
                var found = $scope.status.theDocTypeOptions.find(function(it) {
                    return String(it.value) === String(item.articleType);
                });
                return found ? found.name : undefined;
            };
            /**
             * [addChildRefresh description] 监听子页面保存，并刷新本身
             */
            function addChildRefresh() {
                window.addEventListener(
                    'storage',
                    function (e) {
                        if (e.key === 'ls.refresh') {
                            requestData();
                        }
                    },
                    false
                );
            }

            function initData() {
                $scope.requestData = requestData;
                requestData();
                getTheFirstTypes();
            }
            // 获取一级分类
            function getTheFirstTypes() {
                httpService.http('/mcnww/web/classic/classicList.do', '', 'get').then(function (res) {
                    $scope.status.theFirstTypeOptions = $scope.status.theFirstTypeOptions.concat(
                        res.data.map(function (item) {
                            return {
                                name: item.departName,
                                value: item.id
                            };
                        })
                    );
                    res.data[0] && getTheSecondTypes(res.data[0]);
                });
            }
            // 获取二级分类
            function getTheSecondTypes(item) {
                if (item.id === undefined) return;
                httpService.http('/mcnww/web/classic/classicList.do', { id: item.id }, 'get').then(function (res) {
                    // console.log(res);
                    $scope.status.theSecondTypeOptions = $scope.status.theSecondTypeOptions.concat(
                        res.sList.map(function (item) {
                            return {
                                name: item.departName,
                                value: item.id
                            };
                        })
                    );
                    $scope.status.theSecondType = angular.copy($scope.status.theSecondTypeOptions[0]);
                });
            }
            // 一级分类 change 事件
            $scope.firstTypeChange = function () {
                $scope.status.theSecondType = angular.copy($scope.status.theSecondTypeOptions[0]);
                requestData();
                getTheSecondTypes($scope.status.theFirstType);
            };
            /**
             * [createDraft description] 新建稿件
             * @return {[type]} [description]
             */
            $scope.createDraft = function () {
                // HttpService
                var loginUser = JSON.parse(sessionStorage.getItem('loginUser'));
                if (loginUser && loginUser.unit == '') {
                    modalDialog.success('请先填写工作单位', 'error', false, function () { });
                    return;
                }
                // debugger;
                var url = $state.href('editpage', { type: 4 });
                window.open(url);
            };
            /**
             * [requestData description] 初始化列表数据
             */
            function requestData() {
                $scope.data.selectedArray = [];
                $scope.params.firstClassId = $scope.status.theFirstType.value;
                $scope.params.secondClassId = $scope.status.theSecondType.value;
                $scope.params.articleType = $scope.status.theDocType.value;
                $scope.loadingPromise = httpService.http('/mcnww/web/article/draftList.do', $scope.params, 'get').then(function (data) {
                    $scope.data.listData = data.data.ldata;
                    $scope.page = {
                        CURRPAGE: data.data.startPage,
                        PAGESIZE: data.data.pageSize,
                        ITEMCOUNT: data.data.totalResults,
                        PAGECOUNT: data.data.totalPages
                    };
                    for (var i = 0; i < $scope.data.listData.length; i++) {
                        $scope.data.listData[i].newTime = $filter('date')($scope.data.listData[i].oprTime, 'yyyy-MM-dd HH:mm:ss').toString();
                    }
                });
            }
            /**
             * [queryByDropdown description] 筛选条件触发后请求数据
             * @param  {[type]} key   [description] 请求对象参数key
             * @param  {[type]} value [description] 请求对象值
             * @return {[type]}       [description] null
             */
            $scope.queryByDropdown = function () {
                $scope.params.startTime = $scope.status.startDate;
                $scope.params.endTime = $scope.status.endDate;

                requestData();
            };
            /**
             * [fullTextSearch description;全文检索]
             * @param  {[type]} ev [description:按下回车也能提交]
             */
            $scope.fullTextSearch = function (ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    // $scope.params.searchWord = $scope.data.keywords;
                    requestData();
                }
            };
            /**
             * [selectDoc description] 单选
             * @param  {[type]} item [description] 当前数据
             * @return {[type]}      [description]
             */
            $scope.selectDoc = function (item) {
                var index = $scope.data.selectedArray.indexOf(item);
                index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
            };
            /**
             * [selectPanel description] 全选当前面板的稿件
             * @param  {[type]} items [description] 当前面板
             * @return {[type]}       [description]
             */
            $scope.selectPanel = function (items) {
                if ($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
                    $scope.data.selectedArray = [];
                } else {
                    $scope.data.selectedArray = [].concat($scope.data.listData);
                }
            };
            /**
             * [deleteList description;删除稿件]
             * @param  {[type]} id
             */
            $scope.deleteList = function () {
                modalDialog.confirmModal('删除', '确认删除选中稿件吗？', function () {
                    var params = {
                        ids: ''
                    };
                    multipleId($scope.data.selectedArray, params);
                    httpService.http('/mcnww/web/article/delete.do', params, 'get').then(function (data) {
                        requestData();
                    });
                });
            };
            $scope.toDetail = function (item) {
                var url = $state.href('editpage', { id: item.id, type: 6 }, { reload: 'editpage' });
                if (item.articleType === 2) {
                    url = $state.href('editvideo', { id: item.id, type: 7 }, { reload: 'editvideo' });
                } else if (item.articleType === 3) {
                    url = $state.href('editImage', { id: item.id, type: 8 }, { reload: 'editvideo' });
                }
                window.open(url, '_blank');
            };
            /**
             * [submission description;投稿]
             * @param  {[type]} id
             */
            $scope.submission = function () {
                // modalDialog.confirmModal("投稿", "投稿成功", function() {
                var params = {
                    ids: ''
                };
                multipleId($scope.data.selectedArray, params);
                httpService.http('/mcnww/web/article/contribute.do', params, 'get', true).then(function (data) {
                    modalDialog.success('投稿成功', 'success', false, function () { });
                    requestData();
                },
                    function (data) {
                        if (data.message === '稿件中存在未转码完成的视频!') {
                            modalDialog.alertType('投稿失败', '稿件中存在正在转码的视频，请耐心等待，稍后再试。', 'error', false);
                        } else {
                            modalDialog.alertType("错误", data.message, "error", false);
                        }
                    });
                // });
            };
            /**
             * [multipleId description;判读多个id]
             * @param  {[type]} 选中元素的集合
             */
            function multipleId(items, params) {
                if (items.length > 1) {
                    var newIds = [];
                    for (var i = 0; i < items.length; i++) {
                        newIds.push(items[i].id);
                    }
                    params.ids = newIds.join(',');
                } else {
                    params.ids = trsspliceString.spliceString(items, 'id', ',');
                }
            }
            /**
             * [pageChanged description]分页请求
             * @return {[type]} [description]
             */
            $scope.pageChanged = function () {
                $scope.params.currPage = $scope.page.CURRPAGE;
                // $scope.status.jumpToPageNum = $scope.page.CURRPAGE;
                requestData();
            };
            /**
             * [jumpToPage description:跳转指定页面]
             */
            $scope.jumpToPage = function () {
                jumpToPage();
            };

            function jumpToPage() {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.params.currPage = $scope.status.copyCurrPage;
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                requestData();
            }
            /**
             * [pageChanged description]分页请求
             * @return {[type]} [description]
             */
            $scope.pageChanged = function () {
                $scope.params.currPage = $scope.page.CURRPAGE;
                // $scope.status.jumpToPageNum = $scope.page.CURRPAGE;
                requestData();
            };
        }
    ]);
